
import { Component, Vue, Watch } from 'vue-property-decorator'
import BasePage from '../BasePage.vue'
import UploadMaterial from '../components/Upload/UploadMaterial.vue'
import { editOrder } from '@/api/placeOrder'
import { IServiceMap } from '@/business/BusinessFormData'
import { IFormMap } from '@/store/modules/formMap'
import { ICustomerAppKey, IOrganization } from '@/store/state'
import { IOrderForm } from '@/types/placeOrderTypes'
import _ from 'lodash'
import { Getter } from 'vuex-class'
import BasicInfo from '../components/BasicInfo.vue'
import XdocProjectPlanForWord from '../components/XdocProjectPlanForWord.vue'
import { getDefaultForm } from '../helper'
import XdocProjectPlan from '../components/XdocProjectPlan.vue'

@Component({
  components: {
    BasePage,
    BasicInfo,
    UploadMaterial,
    XdocProjectPlanForWord,
    XdocProjectPlan,
  },
})
export default class PlaceOrder extends Vue {
  @Getter('order_id') order_id!: string
  @Getter('customerAppKey') customerAppKey!: ICustomerAppKey
  @Getter('organization') organization!: IOrganization
  @Getter('formMap')
  formMap!: IFormMap

  defaultForm: IOrderForm = {} as IOrderForm
  form: IOrderForm = {} as IOrderForm
  formInfo: null | IServiceMap = null
  regBookName = false

  digit_delivery = 3
  type = ''
  name = ''
  reEdit = false

  @Watch('form.material', { deep: true })
  createXdocPlanning() {
    if (!this.form.material) return
    if (this.form.material.type === 3 && this.form.material.oss_pdf_files.length) {
      this.form.xdoc_planning = [
        {
          name: this.form.alias,
          config: {
            delivery: this.form.service_content === 5 ? 3 : 1,
          },
          origin_files: this.form.material.oss_pdf_files.map(item => {
            return {
              name: item.name,
              type: item.type === 'answer' ? 0 : 1,
            }
          }),
          is_del: false,
        },
      ]
    }
  }

  BaseMounted(serviceType: string, name: string) {
    this.type = serviceType
    this.name = name
    this.formInfo = this.formMap.formMap![serviceType]
    this.defaultForm = getDefaultForm(serviceType, this.formInfo, this.organization, this.customerAppKey, name)
  }
  FormChange(form: IOrderForm) {
    this.form = form
  }

  creatCheckForm(form: IOrderForm) {
    if (!form.book_name) return this.$message.error('请输入图书名称')
    if (!form.alias) return this.$message.error('请输入工单别名')
    if (!form.subject) return this.$message.error('请选择学科')
    if (!form.stage) return this.$message.error('请选择学段')
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.book_name)) {
      this.regBookName = true
      return this.$message.error('图书名称含有非法字符')
    }
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.alias)) {
      return this.$message.error('工单别名含有非法字符')
    }
  }

  submitCheckForm(bounds: any, callback: (val: boolean) => void) {
    // 文件检查
    if (this.form.material.type === 0 && !this.form.material.oss_fbd_zips?.length)
      return this.$message.error('请上传zip文件')
    else if (this.form.material.type === 1 && !this.form.material.oss_word_files?.length)
      return this.$message.error('请上传word文件')
    else if (this.form.material.type === 2 && !this.form.material.oss_images?.length) {
      this.$message.error('请上传图片文件')
      return callback(true)
    } else if (this.form.material.type === 3 && !this.form.material.oss_pdf_files?.length) {
      this.$message.error('请上传pdf文件')
      return callback(true)
    }

    if (!this.form.xdoc_planning?.length) {
      this.$message.error('请选择要制作的内容')
      return callback(true)
    }

    const names = this.form.xdoc_planning.map(item => item.name)
    if (Array.from(new Set(names)).length !== this.form.xdoc_planning.length) {
      this.$message.error('制作内容中有重名项目')
      return callback(true)
    }

    // 清除开发添加的字段
    for (const i of this.form.xdoc_planning) {
      if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(i.name || '')) {
        this.$message.error('制作内容含有非法字符')
        return callback(true)
      }

      if (!i.origin_files!.filter(fbd => fbd.type === 1).length) {
        this.$message.error('制作内容中未选择正文fbd文件')
        return callback(true)
      }
      if (this.form.material.type === 4 && !i.compare_pdf!.filter(pdf => pdf.type === 1).length) {
        this.$message.error('制作内容中未选择正文fbd文件')
        return callback(true)
      }

      if (i.config.fbd_type === 1) {
        if (!i.origin_files!.filter(fbd => fbd.type === 0).length) {
          this.$message.error('制作内容中未选择答案fbd文件')
          return callback(true)
        }
        if (this.form.material.type === 4 && !i.compare_pdf!.filter(pdf => pdf.type === 0).length) {
          this.$message.error('制作内容中未选择答案fbd文件')
          return callback(true)
        }
      }
    }

    return callback(false)
  }

  async submit(formData: any) {
    if (this.form.material.type === 1 && this.form.xdoc_planning.length) {
      this.form.xdoc_planning.map(plan => {
        if (plan.config.fbd_type !== 0) plan.config!.is_word_json_o2o = false
      })
    }

    if (this.digit_delivery && formData.material.type === 3) {
      formData.xdoc_planning &&
        formData.xdoc_planning.map((projetct: any) => {
          projetct.config.delivery = this.digit_delivery
        })
    }
  }

  screenForm(form: any) {
    const keys = Object.keys(form)
    const defaultKeys = Object.keys(this.defaultForm)
    const screenkeys = keys.filter(item => defaultKeys.includes(item))
    const screenForm: any = {}
    screenkeys.forEach(item => {
      screenForm[item] = form[item]
    })
    return screenForm
  }

  fileType = 0
  showMore = false
  handleFileTypeChange(e: number) {
    if (e === 0) {
      this.showMore = true
    } else {
      this.showMore = false
    }
    if (e !== 2) {
      this.form.xdoc_planning = []
    }
    setTimeout(() => {
      this.$set(this.form.material, 'type', e)
      this.fileType = e
    }, 100)
  }

  async handleSaveForm() {
    await editOrder({ ticket_id: this.order_id, ...this.screenForm(this.form) })
  }
}
